import { Card, CardContent, Stack } from "@altimateai/lego";
import styles from "./styles.module.scss";
import classnames from "classnames";
import { LevelTag, TableTags, type Level } from "../../components/tags";
import list_icon from "../../assets/icons/list.svg";
import dayjs from "dayjs";
import { default as ViolationIcon } from "../../assets/icons/violation_icon.svg?react";
import type { ContractDetailResponse } from "./types";

type PolicyItem = ContractDetailResponse["policies"][number];

interface PolicyProps {
  policies: PolicyItem[];
}

const Policy = ({ policies }: PolicyProps) => {
  return (
    <Card className="m-0 overflow-y">
      <CardContent className="overflow-y al-pt-4">
        <Stack align="center">
          <div className="me-2 fs-5 fw-semibold">Policy List</div>
          <div className={styles.count_label}>{policies.length}</div>
        </Stack>

        <div className={styles.policies_container}>
          {policies.map(item => (
            <div key={item.policy_id} className={styles.card}>
              <Stack align="center" justify="between" className="mb-2">
                <div className="bg-primary p-2 br-2">
                  <img src={list_icon} alt="" />
                </div>
                <Stack align="center">
                  <Stack align="end" className="me-3">
                    {item.last_violation_timestamp && (
                      <>
                        <div className="me-2 level-orange icon-sm">
                          <ViolationIcon />
                        </div>
                        <div>{dayjs(item.last_violation_timestamp).format("DD MMM, YYYY")}</div>
                      </>
                    )}
                  </Stack>
                  <LevelTag level={item.level as Level} />
                </Stack>
              </Stack>
              <div className="mb-2 fs-5 fw-semibold">{item.name}</div>
              {(item.tables.length > 0 || item.description) && (
                <div className={classnames("mt-2 mb-3", styles.divider)} />
              )}
              <TableTags tables={item.tables} />
              <div className="mt-2 text-muted">{item.description}</div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export { Policy };
